module.exports = __webpack_public_path__ + "img/default-w.b5cb6dfe.png";